import { gql } from "@apollo/client"
import { LikeTeamActionFragment } from "./fragments"

export const LIKE_TEAM_MUTATION = gql`
    mutation ToggleLikeTeamMutation($team: String!, $liked: Boolean!) {
        toggleLikeTeam(team: $team, liked: $liked) {
            team {
                id
                ...LikeTeamAction_team
            }
        }
    }
    ${LikeTeamActionFragment}
`
